import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page__controls",
  style: {"margin-top":"2rem","margin-bottom":"2rem"}
}
const _hoisted_2 = { class: "table-controls-text" }
const _hoisted_3 = { class: "table-controls-right" }
const _hoisted_4 = { class: "table-controls-selector-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Назначить")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Отмена")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiSelector = _resolveComponent("UiSelector")!
  const _component_ColorSelector = _resolveComponent("ColorSelector")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_UiTable = _resolveComponent("UiTable")!
  const _component_ViewportObserver = _resolveComponent("ViewportObserver")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UiInput, {
        modelValue: _ctx.objects.filters.address,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objects.filters.address) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => {_ctx.objects.selected = [];})
        ],
        search: "",
        label: "Адрес, ИНН налогоплательщика или название объекта",
        placeholder: "Введите",
        inputId: "filterAddress",
        "use-options": "",
        options: _ctx.searchHints,
        "onUpdate:selectedRow": _cache[2] || (_cache[2] = ($event: any) => (_ctx.objects.filters.address = $event?.value || '')),
        style: {"width":"50rem"}
      }, null, 8, ["modelValue", "options"]),
      _createVNode(_component_UiSelector, {
        options: _ctx.workersFilterOptions,
        modelValue: _ctx.objects.filters.worker,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objects.filters.worker) = $event)),
          _cache[4] || (_cache[4] = ($event: any) => {_ctx.objects.selected = [];})
        ],
        search: "",
        label: "Сотрудник",
        placeholder: "Выберите сотрудника"
      }, null, 8, ["options", "modelValue"]),
      _createVNode(_component_ColorSelector, {
        modelValue: _ctx.objects.filters.status,
        "onUpdate:modelValue": [
          _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objects.filters.status) = $event)),
          _cache[6] || (_cache[6] = ($event: any) => {_ctx.objects.selected = [];})
        ],
        exclude: _ctx.$store.state.auth.isAdmin ? '' : 'DUPLICATE'
      }, null, 8, ["modelValue", "exclude"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-controls", {'table-controls-active': _ctx.objects.selected.length }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$tc('selected', _ctx.objects.selected.length)) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.objects.selected.length), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$tc('objects', _ctx.objects.selected.length)), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_UiSelector, {
            placeholder: "Назначить инспектора",
            options: _ctx.workers.rows,
            modelValue: _ctx.workers.selected,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.workers.selected) = $event))
          }, null, 8, ["options", "modelValue"])
        ]),
        _createVNode(_component_Btn, {
          class: "table-controls-btn",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.objects.onAssign())),
          disabled: _ctx.objects.assigning || !(_ctx.workers.selected?.id)
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Btn, {
          class: "table-controls-btn-outline",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.objects.selected = [])),
          disabled: _ctx.objects.assigning
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 2),
    _createVNode(_component_UiTable, {
      useCheckboxes: !_ctx.$store.state.auth.isCA,
      selectedRows: _ctx.objects.selected,
      "onUpdate:selectedRows": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objects.selected) = $event)),
      cols: _ctx.cols,
      rows: _ctx.objects.rows,
      "empty-banner-text": _ctx.objects.fetching ? '' : 'Нет данных',
      showIndex: ""
    }, null, 8, ["useCheckboxes", "selectedRows", "cols", "rows", "empty-banner-text"]),
    (_ctx.objects.showLoader)
      ? (_openBlock(), _createBlock(_component_ViewportObserver, {
          key: 0,
          onShow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.objects.fetchNextPage()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}